import { render, staticRenderFns } from "./SwipeUser.vue?vue&type=template&id=faf89880&"
import script from "./SwipeUser.vue?vue&type=script&lang=js&"
export * from "./SwipeUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports